/**
 * Controlled three-way filter chip group used in both the bell dropdown and
 * the full notifications page.
 *
 * Props:
 *   value:    'all' | 'unread' | 'action'
 *   onChange: (next) => void
 *   counts:   { all: number, unread: number, action: number }
 *   size:     'sm' (default, dropdown) | 'md' (page)
 */
export function SeverityFilter({ value, onChange, counts, size = 'sm' }) {
  const padding = size === 'md' ? 'px-3 py-1.5 text-sm' : 'px-2.5 py-1 text-xs';
  return (
    <div className="flex items-center gap-1.5" role="tablist" aria-label="Filter notifications">
      {CHIPS.map((chip) => {
        const active = value === chip.key;
        const count = counts?.[chip.key] ?? 0;
        return (
          <button
            key={chip.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(chip.key)}
            className={[
              'inline-flex items-center gap-1.5 rounded-full border font-medium transition-colors',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-primary-500 dark:focus-visible:ring-carbon-400 dark:focus-visible:ring-offset-slate-950',
              padding,
              active
                ? 'border-primary-600 bg-primary-600 text-white dark:border-carbon-500 dark:bg-carbon-500 dark:text-slate-900'
                : 'border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800',
            ].join(' ')}
          >
            <span>{chip.label}</span>
            {count > 0 && (
              <span
                className={[
                  'inline-flex min-w-[18px] items-center justify-center rounded-full px-1 text-xs font-bold leading-4 tabular-nums',
                  active ? 'bg-white/25 text-white dark:bg-slate-900/20 dark:text-slate-900' : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
                ].join(' ')}
              >
                {count > 99 ? '99+' : count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

const CHIPS = [
  { key: 'all',    label: 'All' },
  { key: 'unread', label: 'Unread' },
  { key: 'action', label: 'Action required' },
];
